import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"
import moment from "moment"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import i18n from "i18n"

//empty state
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_basket.png"
import emptyLogin from "assets/images/ugifts/icons/empty/empty_login.png"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import bgProfile from "assets/images/ugifts/profile_bg.png"

import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const Basket = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [listType, setListType] = useState("list_friend")
  const [quantity, setQuantity] = useState(0)
  const [isGuest, setIsGuest] = useState(false)
  const [currency, setCurrency] = useState("")

  const [selecteduDollar, setSelecteduDollar] = useState(null)
  const [selecteduDollarBalance, setSelecteduDollarBalance] = useState(null)
  const [uDollarAmount, setuDollarAmount] = useState(null)

  const [language, setLanguage] = useState("eng")

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    } else {
      setIsGuest(true)
    }

    if (localStorage.getItem("I18N_LANGUAGE")) {
      setLanguage(localStorage.getItem("I18N_LANGUAGE"))
    }

    if (localStorage.getItem("currency")) {
      setCurrency(localStorage.getItem("currency"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      if (!isGuest) {
        getUserProfile()
        getBasketData()
        getUdollarList()
      }
      console.log("use effect")
    }
  }, [token, listType])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [basketData, setBasketData] = useState(null)
  const [giftcardId, setGiftcardId] = useState(null)
  const getBasketData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_basket")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setBasketData(postresponse.table)
      if (postresponse.table.giftcard_id) {
        setGiftcardId(postresponse.table.giftcard_id)
      }
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null && giftcardId) getGiftList()
  }, [giftcardId])

  useEffect(() => {
    if (basketData) {
      var calculate = 0
      basketData.products.forEach(product => {
        calculate += parseInt(product.quantity)
      })
      setQuantity(calculate)
      localStorage.setItem("basketCount", calculate)
    }
  }, [basketData])

  const [udollarData, setUdollarData] = useState(null)
  const getUdollarList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_udollar_giftcards")
    // urlencoded.append("member_id", 52)
    urlencoded.append("member_id", uid)
    urlencoded.append("currency_code", currency)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request udollar list", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUdollarData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [giftData, setGiftData] = useState(null)
  const getGiftList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_giftcard")
    // urlencoded.append("order_by", sortType)
    urlencoded.append("giftcard_id", giftcardId)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard product", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setGiftData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [billing_address, setbilling_address] = useState(null)
  const updateBillingAddress = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "update_billing_address")
    urlencoded.append("member_id", uid)
    urlencoded.append("billing_address", billing_address)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      getBasketData()
      // setsuccess_dlg_noaction(true)
      // setdynamic_title("Billing Address Updated")
      // setdynamic_description(postresponse.message)
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Billing Address Update Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  function onChangeBillingAddress(e) {
    setbilling_address(e.target.value)
  }

  function onChangeuDollarAmount(e) {
    setuDollarAmount(e.target.value)
  }

  const deleteProduct = async pid => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "remove_product")
    urlencoded.append("member_id", uid)
    urlencoded.append("product_id", pid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request delete product", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      getBasketData()
      // setsuccess_dlg_noaction(true)
      // setdynamic_title("Cart Updated")
      // setdynamic_description(postresponse.message)
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Cart Update Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const updateOrderStatus = async status => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "update_order_status")
    urlencoded.append("member_id", uid)
    urlencoded.append("order_status", status) //gift or myself

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      // getBasketData()
      if (postresponse.success) redirectCheckout(status)
      else {
        seterror_alert(true)
        setdynamic_title(props.t("Cart Update Failed"))
        setdynamic_description(postresponse.message)
      }
      // setsuccess_dlg(true)
      // setdynamic_title("Basket Updated")
      // setdynamic_description(postresponse.message)
    } else {
      // seterror_alert(true)
      seterror_alert(true)
      setdynamic_title(props.t("Cart Update Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const removeGiftcard = async status => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "remove_giftcard")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      if (postresponse.success) history.push("/checkout-confirmation")
      else {
        seterror_alert(true)
        setdynamic_title(props.t("Cart Update Failed"))
        setdynamic_description(postresponse.message)
      }
    } else {
      // seterror_alert(true)
      seterror_alert(true)
      setdynamic_title(props.t("Cart Update Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const applyUdollar = async () => {
    if (!selecteduDollar) {
      seterror_alert(true)
      setdynamic_title(props.t("Please choose a uDollar giftcard"))
      setdynamic_description("")
      return
    }

    if (!uDollarAmount) {
      seterror_alert(true)
      setdynamic_title(props.t("Please enter a valid redemption amount"))
      setdynamic_description("")
      return
    }

    if (uDollarAmount > parseInt(selecteduDollarBalance)) {
      seterror_alert(true)
      setdynamic_title(props.t("Please enter a valid redemption amount"))
      setdynamic_description("")
      return
    }

    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "apply_udollar_giftcard")
    urlencoded.append("member_id", uid)
    urlencoded.append("order_id", basketData.id)
    urlencoded.append("udollar_id", selecteduDollar)
    urlencoded.append("udollar_amount", uDollarAmount)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Apply udollar", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      getBasketData()
    } else {
    }
  }

  function redirectCheckout(status) {
    if (status == "gift") {
      history.push("/checkout-cardselection")
    } else {
      removeGiftcard()
    }
  }

  const [modal_billingaddress, setmodal_billingaddress] = useState(false)
  const [modal_udollar, setmodal_udollar] = useState(false)
  const [modal_checkout, setmodal_checkout] = useState(false)

  function tog_billingaddress() {
    setmodal_billingaddress(!modal_billingaddress)
    removeBodyCss()
  }

  function tog_udollar() {
    setmodal_udollar(!modal_udollar)
    removeBodyCss()
  }

  function tog_checkout() {
    setmodal_checkout(!modal_checkout)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  const multiLanguageHandler = data => {
    switch (language) {
      case "eng":
        return data.en
      case "cn":
        return data.cn ? data.cn : data.en
      case "jp":
        return data.jp ? data.jp : data.en
      default:
        return data.en
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  // history.push("/tables-projecttable")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: isGuest ? "56px" : "56px",
                  backgroundColor:
                    basketData &&
                    giftcardId == "0" &&
                    basketData.products.length == 0
                      ? "white"
                      : isGuest
                      ? "white"
                      : "#F5F5F5",
                  paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Cart")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    {/* {basketData &&
                      (giftcardId != "0" || basketData.products.length > 0) && (
                        <Row
                          className="m-0 w-100 p-3 pe-0"
                          style={{
                            height: "80px",
                            backgroundColor: "white",
                            position: "fixed",
                            top: 56,
                            zIndex: 1030,
                            maxWidth: "480px",
                          }}
                          onClick={tog_billingaddress}
                        >
                          <Col>
                            <Row>
                              <Col className="ps-0" xs="10">
                                <Row>
                                  <Col>
                                    <span
                                      className={"font-size-15 text-dark"}
                                      style={{ fontWeight: 500 }}
                                    >
                                      {"Billing address"}
                                    </span>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <p
                                      className={"font-size-15 text-dark mb-0"}
                                      style={{
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {basketData && basketData.billing_address}
                                    </p>
                                  </Col>
                                </Row>
                              </Col>
                              <Col xs="2" className="pe-0 align-self-center">
                                <Button
                                  className="m-0"
                                  onClick={() => {
                                    // history.goBack()
                                  }}
                                >
                                  <i className="bx bx-chevron-right align-middle font-size-20 text-light" />
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )} */}
                    {giftData && giftcardId != "0" && (
                      <Row className="p-3">
                        <Col>
                          <span
                            className="font-size-20 text-dark"
                            style={{ fontWeight: 500 }}
                          >
                            {props.t("Gift Cards")}
                          </span>
                        </Col>
                      </Row>
                    )}
                    {giftData && giftcardId != "0" && (
                      <Row>
                        <Col>
                          <Card
                            className="mb-0 shadow-none p-3"
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "white",
                            }}
                          >
                            <CardImg
                              top
                              className="img-fluid mb-3"
                              src={giftData.image_thumbnail}
                              alt=""
                              style={{
                                aspectRatio: "3/2",
                                objectFit: "cover",
                                borderRadius: "14px",
                              }}
                            />
                            <span className="font-size-15 pt-0">
                              {props.t(
                                "You can change and customize your card after checkout"
                              )}
                            </span>
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {basketData &&
                      giftcardId == "0" &&
                      basketData.products.length == 0 && (
                        <UgiftEmptyState
                          image={emptyImage}
                          title={props.t("There are no items in the cart")}
                          link="/categories"
                          linkText={props.t("Shop Now")}
                        />
                      )}
                    {basketData &&
                      (giftcardId != "0" || basketData.products.length > 0) && (
                        <Row className="p-3">
                          <Col xs="6">
                            <span
                              className="font-size-20 text-dark"
                              style={{ fontWeight: 500 }}
                            >
                              {" "}
                              {props.t("Order Summary")}
                            </span>
                          </Col>
                          <Col
                            xs="6"
                            className="font-size-14 text-end align-self-center"
                            style={{ fontWeight: 500 }}
                          >
                            <Link
                              to={
                                basketData && giftcardId == "0"
                                  ? "/categories"
                                  : "/gift-card-product?id=" + giftcardId
                              }
                            >
                              {props.t("Add items")}
                            </Link>
                          </Col>
                        </Row>
                      )}
                    <Row>
                      <Col>
                        {basketData &&
                          basketData.products.map((data, index) => (
                            <Card
                              className="mb-0 p-3 shadow-none"
                              style={{
                                borderRadius: "0px",
                                // width: "160px",
                                // height: "196px",
                                backgroundColor: "white",
                              }}
                            >
                              <Row>
                                <Col xs="auto">
                                  <img
                                    src={data.image}
                                    className="avatar-lg"
                                    alt=""
                                    style={{
                                      borderRadius: "8px",
                                      maxWidth: "72px",
                                      maxHeight: "72px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </Col>
                                <Col>
                                  <Row>
                                    <Col>
                                      <strong>
                                        <span className="font-size-15 text-dark">
                                          {
                                            multiLanguageHandler(
                                              data.multiple_languages
                                            ).product_name
                                          }
                                        </span>
                                      </strong>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col>
                                      <span className="font-size-15 text-secondary">
                                        {props.t("Qty") + ": " + data.quantity}
                                      </span>
                                    </Col>
                                    <Col className="text-end">
                                      <span className="font-size-15 text-secondary">
                                        {data.currency_code + " " + data.amount}
                                      </span>
                                    </Col>
                                  </Row>
                                  {data.campaign_info &&
                                    (data.campaign_info.discount_mode ? (
                                      <Row className="mt-2">
                                        <Col>
                                          <i className="bx bxs-discount align-middle font-size-20 text-danger me-2" />
                                          <span className="font-size-15 text-dark align-middle">
                                            {
                                              data.campaign_info
                                                .discount_message
                                            }
                                          </span>
                                        </Col>
                                      </Row>
                                    ) : null)}
                                  <Row className="mt-1">
                                    <Col>
                                      <Link
                                        to={
                                          "/product-details?id=" +
                                          data.product_id
                                        }
                                      >
                                        <button className="btn btn-link px-0">
                                          {props.t("Edit")}
                                        </button>
                                      </Link>
                                    </Col>
                                    <Col xs="auto">
                                      <button
                                        className="btn btn-link px-0"
                                        onClick={() => {
                                          deleteProduct(data.product_id)
                                        }}
                                      >
                                        <i className="bx bx-trash align-middle font-size-18 text-primary" />
                                      </button>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </Card>
                          ))}
                        {basketData &&
                          (giftcardId != "0" ||
                            basketData.products.length > 0) && (
                            <Card
                              className="mb-0 p-3 shadow-none"
                              style={{
                                borderRadius: "0px",
                                // width: "160px",
                                // height: "196px",
                                backgroundColor: "white",
                              }}
                            >
                              {/* <Row className="mb-1">
                              <Col>
                                <span>{"Quantity"}</span>
                              </Col>
                              <Col className="text-end">
                                <span>{quantity}</span>
                              </Col>
                            </Row> */}
                              <Row className="mb-1">
                                <Col>
                                  <span>{props.t("Subtotal")}</span>
                                </Col>
                                <Col className="text-end">
                                  <span>{basketData.sub_total}</span>
                                </Col>
                              </Row>
                              {/* <Row className="mb-1">
                              <Col>
                                <span>
                                  {"GST " + basketData.tax_percentage + "%"}
                                </span>
                              </Col>
                              <Col className="text-end">
                                <span>{basketData.tax}</span>
                              </Col>
                            </Row> */}
                              <Row className="mb-1">
                                <Col>
                                  <span style={{ color: "#00BB66" }}>
                                    {props.t("Discount Applied")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span style={{ color: "#00BB66" }}>
                                    {basketData.total_discount}
                                  </span>
                                </Col>
                              </Row>
                              {/* <Row className="mb-1">
                                <Col>
                                  <span style={{ color: "#00BB66" }}>
                                    {props.t("Points")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span style={{ color: "#00BB66" }}>
                                    {basketData.points}
                                  </span>
                                </Col>
                              </Row> */}
                              <Row className="mt-3">
                                <Col>
                                  <span
                                    className="font-size-18"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {props.t("Total Payment")}
                                  </span>
                                </Col>
                                <Col className="text-end">
                                  <span
                                    className="font-size-18"
                                    style={{ fontWeight: 700 }}
                                  >
                                    {basketData.currency +
                                      " " +
                                      basketData.order_amount}
                                  </span>
                                </Col>
                              </Row>
                            </Card>
                          )}
                        {basketData && (
                          <Card body className="mt-3 p-1">
                            <button
                              className="btn btn-white waves-effect waves-light font-size-14"
                              // style={{ height: "42px" }}
                              onClick={() => {
                                tog_udollar()
                              }}
                            >
                              <i className="bx bx-message-error align-middle font-size-18 text-primary me-2" />
                              <span className="align-middle">
                                {basketData.udollar_amount
                                  ? basketData.currency +
                                    " " +
                                    basketData.udollar_amount
                                  : props.t("Redeem using UDollar")}
                              </span>
                            </button>
                          </Card>
                        )}
                      </Col>
                    </Row>
                    {basketData &&
                      (giftcardId != "0" || basketData.products.length > 0) && (
                        <Row
                          className="m-0 w-100"
                          style={{
                            height: "76px",
                            backgroundColor: "#ffffff",
                            position: "fixed",
                            bottom: 0,
                            zIndex: 1030,
                            maxWidth: "480px",
                            boxShadow:
                              "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                          }}
                        >
                          <Col className="h-100 p-0">
                            <Card body className="mb-0 p-3">
                              <button
                                className="btn btn-danger waves-effect waves-light font-size-18"
                                // style={{ height: "42px" }}
                                onClick={() => {
                                  basketData.giftcard_id != "0" &&
                                  basketData.products.length == 0
                                    ? updateOrderStatus("gift")
                                    : tog_checkout()
                                }}
                              >
                                {props.t("Checkout")}
                              </button>
                            </Card>
                          </Col>
                        </Row>
                      )}
                    {isGuest && (
                      <UgiftEmptyState
                        image={emptyLogin}
                        title={props.t("Welcome, please login to continue")}
                        link={"/login"}
                        linkText={props.t("Login Now")}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_billingaddress}
        toggle={() => {
          tog_billingaddress()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("Billing Address")}
          </h5>
          <button
            type="button"
            onClick={() => {
              tog_billingaddress()
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Row className="mt-2 px-3">
            <Label className="font-size-18 font-weight-bold text-black">
              {props.t("Billing Address")}
            </Label>
            <Col className="">
              <Input
                className="mb-3"
                // label={"Email"}
                placeholder={props.t("Enter Billing Address")}
                type="textarea"
                value={billing_address}
                name="billing_address"
                onChange={onChangeBillingAddress}
                style={{
                  borderRadius: "8px",
                  // border: "none",
                  // height: "50px",
                }}
                defaultValue={basketData && basketData.billing_address}
                // errorMessage={"Please enter your full email"}
                // validate={{ required: { value: true } }}
              />
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_billingaddress()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          <button
            type="button"
            onClick={() => {
              tog_billingaddress()
              updateBillingAddress()
            }}
            className="btn btn-primary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Apply")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
      <Modal
        isOpen={modal_udollar}
        toggle={() => {
          tog_udollar()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("uDollar")}
          </h5>
          <button
            type="button"
            onClick={() => {
              tog_udollar()
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {udollarData &&
            udollarData.map(data => (
              <Row className="px-3">
                <Col>
                  <Card
                    className="p-3"
                    style={{
                      border:
                        selecteduDollar == data.id
                          ? "1px solid #009FE2"
                          : "1px solid #C5CEE0",
                      backgroundColor:
                        selecteduDollar == data.id ? "#F9FEFF" : "#FFFFFF",
                      borderRadius: "8px",
                    }}
                    onClick={() => {
                      setSelecteduDollar(data.id)
                      setSelecteduDollarBalance(data.udollar_balance)
                    }}
                  >
                    <Row>
                      <Col>
                        <Row>
                          <Col className="">
                            <span
                              className="font-size-16 text-black"
                              style={{
                                fontWeight: 700,
                                color: "black",
                              }}
                            >
                              {currency + " " + data.udollar_balance}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="">
                            <span
                              className="font-size-15"
                              style={{
                                // fontWeight: 700,
                                color: "#979797",
                              }}
                            >
                              {moment().isAfter(
                                moment(
                                  data.udollar_expire_date,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              )
                                ? props.t("Expired on") + ": "
                                : props.t("Redeem Before") + ": "}
                              {moment(
                                data.udollar_expire_date,
                                "YYYY-MM-DD HH:mm:ss"
                              ).format("D MMM YYYY")}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={"auto"} className="align-self-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ width: "24px", height: "24px" }}
                          // id="promoFilterCheckBox"
                          checked={data.id == selecteduDollar}
                        />
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            ))}
          {selecteduDollarBalance && (
            <Row className="mt-5 px-3">
              <Label
                className="font-size-16 font-weight-bold text-center"
                style={{ color: "#979797" }}
              >
                {props.t("Key in redemption amount")}
              </Label>
              <Col className="">
                <Input
                  className="mb-3"
                  // label={"Email"}
                  placeholder={props.t("Redemption amount")}
                  type="number"
                  value={uDollarAmount}
                  name="redemption_amount"
                  onChange={onChangeuDollarAmount}
                  style={{
                    borderRadius: "8px",
                    // border: "none",
                    // height: "50px",
                  }}
                  // defaultValue={basketData && basketData.billing_address}
                  // errorMessage={"Please enter your full email"}
                  // validate={{ required: { value: true } }}
                />
              </Col>
              <Label className="font-size-16 font-weight-bold text-center text-black">
                {currency + " " + selecteduDollarBalance}
              </Label>
            </Row>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_udollar()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          <button
            type="button"
            onClick={() => {
              tog_udollar()
              applyUdollar()
            }}
            className="btn btn-danger waves-effect"
            data-dismiss="modal"
          >
            {props.t("Use Now")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
      <Modal
        isOpen={modal_checkout}
        toggle={() => {
          tog_checkout()
        }}
        // className="modal-fullscreen"
        centered={true}
      >
        {/* <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            
          </h5>
          <button
            type="button"
            onClick={() => {
              tog_checkout()
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div> */}
        <div className="modal-body">
          <Row className="mb-2 px-3">
            <button
              type="button"
              onClick={() => {
                updateOrderStatus("myself")
              }}
              className="btn btn-danger waves-effect waves-light font-size-18"
              data-dismiss="modal"
            >
              {props.t("For myself")}
            </button>
          </Row>
          <Row className="mb-2 px-3">
            <button
              type="button"
              onClick={() => {
                updateOrderStatus("gift")
              }}
              className="btn btn-danger waves-effect waves-light font-size-18"
              data-dismiss="modal"
            >
              {props.t("Send as a gift")}
            </button>
          </Row>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_checkout()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Cancel")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(Basket)

Basket.propTypes = {
  t: PropTypes.any,
}
